import {addTagAndDisplayNameFieldsIfNeeded} from '../utils/themeUtils'
import _ from 'lodashParts'

class DocumentServicesStylesManager {
    constructor(documentServices) {
        this.documentServicesApi = documentServices
    }

    getFonts() {
        const getSiteFontsOptions = _.get(this.documentServicesApi, 'fonts.getSiteFontsOptions')

        return getSiteFontsOptions && getSiteFontsOptions()
    }

    getThemes() {
        const getFontsMap = _.get(this.documentServicesApi, 'theme.fonts.getMap')
        const themes = getFontsMap && getFontsMap()

        return addTagAndDisplayNameFieldsIfNeeded(themes)
    }

    getFontUrlsCss() {
        const res = {}

        if (this.documentServicesApi && this.documentServicesApi.fonts) {
            _.forEach(this.documentServicesApi.fonts.css.getUrls(), (url, key) => {
                res[key] = {
                    id: key,
                    value: url,
                    isLink: true,
                    force: false
                }
            })
        }

        return res
    }

    getCssData() {
        const res = {}

        res.viewerCss = {
            id: 'viewerCss',
            value: 'https://static.parastorage.com/services/santa/1.2195.0/static/css/viewer.css',
            isLink: true
        }

        if (this.documentServicesApi && this.documentServicesApi.theme) {
            const getThemeStyles = _.get(this.documentServicesApi, 'theme.fonts.getThemeStyles')

            if (getThemeStyles) {
                res.theme_fonts = {
                    id: 'theme_fonts',
                    value: getThemeStyles(),
                    isLink: false,
                    force: true
                }
            }

            const getCss = _.get(this.documentServicesApi, 'theme.colors.getCss')

            if (getCss) {
                res.theme_colors = {
                    id: 'theme_colors',
                    value: getCss(),
                    isLink: false,
                    force: true
                }
            }
        }

        return res
    }
}

module.exports = DocumentServicesStylesManager



// WEBPACK FOOTER //
// ./src/propsCollector/defaultDocumentServicesStylesManager.js